import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";
import CtHighFivePlayerList from "./CtHighFivePlayerList";
import theyEye from "assets/images/ct/they-know-eye.png";
import twoDice from "assets/images/ct/two-dice.png";
import disLine from "assets/images/ct/dis-line.png";
import { useDispatch } from "react-redux";
import {
  set_ct_selected_player,
  set_ct_selected_card
} from "redux/game/action";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const DiscoveryCardSelector = ({
  roomId,
  titleText = "",
  text1 = "",
  text2 = "",
  text3 = "",
  playersWithCardInfo,
  playerSelected,
  currentPlayer,
  cardSelected,
  buttonPress = () => {},
  diceValue = () => {},
  isDiceSpecial6,buzzer_sound,default_audio_effect
}) => {
  const selectedPlayerInfo =
    playersWithCardInfo?.find((item) => item.id === playerSelected) || {};
  const CardSelectAction = (type) => {
    let data = {};
    switch (type) {
      case "card":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "Steal Card",
          integer: playerSelected,
          string: cardSelected
        };
        break;

      case "roll":
        data = {
          action: "special-action",
          roomId,
          playerId: currentPlayer?.player_id,
          specialAction: "End Turn"
        };
        break;
    }

    Socket.sendMessage(data);
  };

  const handleCardSelectClick = useCallback(
    _.debounce((type) => CardSelectAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [cardSelected, roomId]
  );

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="discovery-main"
    >
      <div
        className={`discovery ${playerSelected != null ? "" : "card-selected"}`}
      >
        <motion.div variants={fadeVariants} className="dis-top">
          <div className="dis-text">
            <img src={theyEye} className="img-fluid" alt="" />
            <div className="text-right">
              <img src={diceValue} className="img-fluid" alt="" />
              <h4>{titleText}</h4>
              <img src={disLine} className="img-fluid disLine" alt="" />
            </div>
          </div>
          <p className="desc">{text1}</p>
          <p className="desc">{text2}</p>
          <p className="desc">{text3}</p>
        </motion.div>
        <CtHighFivePlayerList
          playersWithCardInfo={playersWithCardInfo}
          playerSelected={playerSelected}
          set_ct_selected_player={set_ct_selected_player}
          set_ct_selected_card={set_ct_selected_card}
          selectedPlayerInfo={selectedPlayerInfo}
          cardSelected={cardSelected}
          handleCardSelectClick={() => handleCardSelectClick("card")}
          handleRollButtonClick={() => handleCardSelectClick("roll")}
          buttonText={"END TURN (10)"}
          buttonPress={() => buttonPress()}
          isDiceSpecial6={isDiceSpecial6}
          buzzer_sound={buzzer_sound}
          default_audio_effect={default_audio_effect}
        />
      </div>
    </motion.div>
  );
};

export default DiscoveryCardSelector;
